module.exports = __webpack_public_path__ + "static/media/VAC-light.95bf5d0b.webp";